import { AlertTriangle } from "lucide-react";
import { useMaintenance } from "@/hooks/useMaintenance";

export function MaintenanceBanner() {
  const { config } = useMaintenance();

  if (config.mode === "off") return null;

  const label = config.mode === "full" ? "Maintenance mode" : "Read-only mode";

  return (
    <div className="relative z-50 w-full border-b border-amber-200 bg-amber-100 text-amber-900 dark:border-amber-900 dark:bg-amber-950/60 dark:text-amber-100">
      <div className="container mx-auto px-4 py-2.5 text-center text-sm">
        <span className="inline-flex items-center justify-center gap-2">
          <AlertTriangle className="h-4 w-4 shrink-0" />
          <span className="font-medium">{label}:</span>
          <span>{config.message}</span>
        </span>
      </div>
    </div>
  );
}
